module.exports = {"title":"1:1 문의","replyStatus":"답변 여부","answered":"답변완료","checking":"확인중","registerReply":"답변등록","editReply":"수정하기","typeService":"서비스","typeEvent":"이벤트","typeUpdate":"업데이트"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cs102.json
// module id = JMmA
// module chunks = 2